module.exports = __webpack_public_path__ + "img/IMG_2007.69269d9f.jpg";